<template>
  <div class="wrapper">
        <CRow class="mt-3">
          <CCol  sm="4">
            <CCard>
              <CCardHeader> <b> Discover Form </b> </CCardHeader>
             <CCardBody>
              <CRow>
                <CCol sm="12" >
                <b-form-checkbox id="checkbox-1" v-model="cb_redirect" name="checkbox-1">redirected?</b-form-checkbox>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="12" >
                <label> <b> Title </b> </label>
                <b-input v-model="form.title" placeholder='Title' :class="errors.title ? 'is-invalid' : ''"  id="feedback-user" class="mb-1"> </b-input>
                <b-form-invalid-feedback >
                Your title must be filled
                </b-form-invalid-feedback>
                </CCol>
              </CRow>
             <CRow class="mt-3" v-if="!cb_redirect">
              <CCol >
                <label> <b> URL </b> </label>
                <b-input v-model="form.url" placeholder='www.example.com' class="mb-1"> </b-input>  
              </CCol>
            </CRow>
             <CRow class="mt-3" v-if="!cb_redirect">
              <CCol >
                <label> <b> Author </b> </label>
              <b-input v-model="form.author" placeholder='Author' class="mb-1"> </b-input>
              </CCol>
            </CRow>
            
            <CRow class="mt-3" v-if="!cb_redirect">
              <CCol >
              <label> <b> Description </b> </label>
              <c-textarea v-model="form.description" placeholder='Description'  class="mb-1"> </c-textarea>
              </CCol>
            </CRow>
            <hr>
            <label> <b> Card Image </b> </label>
            <CRow>
              <CCol >
              
              <img v-bind:src="form.card_image" style="width:200px"/>
              <b-form-file v-if="btn_create" v-model="form.card_image" plain></b-form-file>
               <CButton class="ml-3"  v-if="btn_update" type="button" @click="openModalPhotoCardImage(form.id)"  variant="outline" color="info">Change Image</CButton>

              </CCol>
            </CRow>
          
              <label class="mt-3" v-if="!cb_redirect"> <b> Background Image </b> </label>
              <CRow v-if="!cb_redirect">
                <CCol >
                <img v-bind:src="form.bg_image" style="width:200px"/>
                <b-form-file v-if="btn_create" v-model="form.bg_image"  plain></b-form-file>    
                <CButton  class="ml-3" v-if="btn_update" type="button" @click="openModalPhotoBGImage(form.id)"  variant="outline" color="info">Change Image</CButton>
                </CCol>
              </CRow>
              <hr>
            <CRow class="mt-3" v-if="!cb_redirect">
              <CCol >
              <label> <b> Mobile Setting </b> ( kosongi jika ingin settingan default )</label>

             <CRow>
              <CCol sm="6" >
              <label>Back Button Text Color</label> <div :style="{backgroundColor: form.mobile_setting.back_button_setting.color }">current color {{ form.mobile_setting.back_button_setting.color }}</div> 
              <CButton class="btn btn-sm" type="button" @click="clear('Back Button Text Color')"  variant="outline" color="info">clear</CButton>
              <br>
              <colorpicker :color="form.mobile_setting.back_button_setting.color" v-model="form.mobile_setting.back_button_setting.color"/>
              <br>
              </CCol>
              <CCol sm="6" >
              <label>Back Button BG Color</label> <div :style="{backgroundColor: form.mobile_setting.back_button_setting.bg_color }">current color {{ form.mobile_setting.back_button_setting.bg_color }}</div>
              <CButton class="btn btn-sm" type="button" @click="clear('Back Button BG Color')"  variant="outline" color="info">clear</CButton>
              <br>
              <colorpicker :color="form.mobile_setting.back_button_setting.bg_color" v-model="form.mobile_setting.back_button_setting.bg_color" />
              <br>
              </CCol>
            </CRow>

             <CRow>
              <CCol sm="6" >
              <label>Title Text Color</label> <div :style="{backgroundColor: form.mobile_setting.title.color }">current color {{ form.mobile_setting.title.color }}</div>
              <CButton class="btn btn-sm" type="button" @click="clear('Title Text Color')"  variant="outline" color="info">clear</CButton>
              <br>
              <colorpicker :color="form.mobile_setting.title.color" v-model="form.mobile_setting.title.color" />
              <br>
              </CCol>
              <CCol sm="6" >
              <label>Title BG Color</label> <div :style="{backgroundColor: form.mobile_setting.title.bg_color }">current color {{ form.mobile_setting.title.bg_color }}</div>
              <CButton class="btn btn-sm" type="button" @click="clear('Title BG Color')"  variant="outline" color="info">clear</CButton>
              <br>
              <colorpicker :color="form.mobile_setting.title.bg_color" v-model="form.mobile_setting.title.bg_color" />
              <br>
              </CCol>
            </CRow>
              

             <CRow>
              <CCol sm="6" >
              <label>Author Text Color</label> <div :style="{backgroundColor: form.mobile_setting.author.color }">current color {{ form.mobile_setting.author.color }}</div>
              <CButton class="btn btn-sm" type="button" @click="clear('Author Text Color')"  variant="outline" color="info">clear</CButton>
              <br>
              <colorpicker :color="form.mobile_setting.author.color" v-model="form.mobile_setting.author.color" />
              <br>
              </CCol>
            </CRow>

             <CRow>
              <CCol sm="6" >
              <label>Content BG Color</label> <div :style="{backgroundColor: form.mobile_setting.bg_content }">current color {{ form.mobile_setting.bg_content }}</div>
              <CButton class="btn btn-sm" type="button" @click="clear('Content BG Color')"  variant="outline" color="info">clear</CButton>
              <br>
              <colorpicker :color="form.mobile_setting.bg_content" v-model="form.mobile_setting.bg_content" />
              <br>
              </CCol>
            </CRow>

              </CCol>
            </CRow>


             </CCardBody>
            </CCard>
          </CCol>
          <CCol sm="8">
            <CCard>
              <CCardBody>
              <CRow class="mt-3" v-if="!cb_redirect">
                <CCol >
                <label> Rich Text </label>
                <editor id="editor" v-model="form.rich_text" api-key="hq3wl53w9617r84m5cjgkm5h18xckn5mtfl0bvlkkytchrv8" :init="init">{{ form.rich_text }}</editor>
                </CCol>
              </CRow>   
              <CRow class="mt-3" v-if="cb_redirect">
                <CCol >
                <label> Redirect to: (ex: article)</label>
                <b-input v-model="form.redirect_to" class="mb-1"> </b-input> 
                </CCol>
              </CRow>  
              </CCardBody>
            </CCard>
            <CButton v-if="btn_create" block type="submit" v-on:click.prevent="create()"   color="info"><b>Create </b></CButton>
            <CButton v-if="btn_update" block type="submit" v-on:click.prevent="update(form.id)"   color="info">Update</CButton>
          </CCol>
        </CRow>  
        <br><br>
        <alertmodal></alertmodal>
        <modalphotobg></modalphotobg>
        <modalphotocard></modalphotocard>
        <!-- <pre>{{ $data | json }}</pre> -->
  </div>
</template>

<script>
import EventBus from '@/eventBus';
import alertmodal from '@/views/alert/modal.vue';

import discover from '@/services/discover'

//import tinymce from "vue-tinymce-editor";
import Editor from '@tinymce/tinymce-vue';

import modalphotobg from './discover_modal_photo_bgimage.vue';
import modalphotocard from './discover_modal_photo_cardimage.vue';

import InputColorPicker from 'vue-native-color-picker'

import Vue from 'vue'



export default {
name: 'discoverform',
  components: {
    alertmodal,
    'editor': Editor, 
    modalphotobg,modalphotocard,
    "v-input-colorpicker": InputColorPicker,
    //'chrome-picker': Chrome
    //tinymce
  },
  data () {
    return {
      errors: {},
      errors_from_backend: [],
      loading: false,
        form:{
            id: '',
            title: '',
            title_color: '',
            url:'',
            author:'',
            description:'',
            rich_text:'',
            card_image:'',
            bg_image:'',
            mobile_setting:{
              back_button_setting:{
                color: '',
                bg_color:''
              },
              title:{
                color:'',
                bg_color:''
              },
              author:{
                color:'',
              },              
              bg_content:'',              
            },
            redirect_to:'',
        },
        cb_redirect:'',
        btn_create: 0,
        btn_update: 0,
        init: {
            height: 500,
            init_instance_callback : function(editor) {
                var freeTiny = document.querySelector('.tox .tox-notification--in');
            freeTiny.style.display = 'none';
            },
            plugins: [
            'advlist autolink lists link image charmap',
            'searchreplace visualblocks',
            'insertdatetime table paste code wordcount',
            'autosave',
            ],
            content_style: "body { background-color: #D1B3A0; }",
            toolbar:
            'restoredraft | undo redo | formatselect | bold italic forecolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent | removeformat',
            //custom menu
            menu : { 
              file: {title: 'File', items: 'newdocument'},
              edit: {title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall'},
              insert: {title: 'Insert', items: 'image link media template codesample'},
              format: {title: 'Format', items: 'bold italic underline | formats align forecolor'},
            },
            autosave_interval: '1s',
            // autosave_prefix: 'tinymce-autosave-{path}{query}-{id}-',
            images_upload_credentials: true,
            //images_upload_url: 'http://localhost:3300/imageupload/postAcceptor.php',
            images_upload_handler: function (blobInfo, success, failure) {
            var xhr, formData;
            xhr = new XMLHttpRequest();
            xhr.withCredentials = false;
            //xhr.open('POST', 'http://localhost:8005/api/testupload');
            xhr.open('POST', process.env.VUE_APP_URL +'/upload_image_tinymce');
            xhr.onload = function() {
                var json;

                if (xhr.status != 200) {
                failure('HTTP Error: ' + xhr.status);
                return;
                }
                json = JSON.parse(xhr.responseText);

                if (!json || typeof json.location != 'string') {
                failure('Invalid JSON: ' + xhr.responseText);
                return;
                }
                success(json.location);
            };
            formData = new FormData();
            formData.append('file', blobInfo.blob(), blobInfo.filename());
            xhr.send(formData);
            }
        },   
      
    }
  },
   computed: {
   },
  mounted(){
    this.loadData()
    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });

  },
  created () {

  },

  

  methods: {
      loadData(){
        if(this.$route.query.id){
            this.btn_update = 1;

            discover.getDiscoverbyID(this.$route.query.id)
            .then(res => {
                this.form.id = res.data.id;
                this.form.title = res.data.title;
                this.form.title_color = res.data.title_color;
                this.form.url = res.data.url;
                this.form.author = res.data.author;
                this.form.description = res.data.description;
                this.form.rich_text = res.data.rich_text;
                this.form.card_image = res.data.card_image;
                this.form.bg_image = res.data.bg_image;
                if(res.data.mobile_setting !== null){
                  this.form.mobile_setting = JSON.parse(res.data.mobile_setting);
                }
                if(res.data.redirect_to !== null){
                  this.cb_redirect = true;
                  this.form.redirect_to = res.data.redirect_to;
                }
                //this.form.mobile_setting = !empty(res.data.mobile_setting) ? JSON.parse(res.data.mobile_setting) : '';
            }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
            })
        }else{
            this.btn_create = 1;
        }
      },

    create(){
      let formData = new FormData();
      formData.append('card_image', this.form.card_image );
      formData.append('bg_image', this.form.bg_image );
      formData.append('description', this.form.description );
      formData.append('title', this.form.title );
      formData.append('title_color', this.form.title_color );
      formData.append('author', this.form.author );
      formData.append('url', this.form.url );
      formData.append('rich_text', this.form.rich_text );
      formData.append('mobile_setting', JSON.stringify(this.form.mobile_setting) );
      if(this.cb_redirect == true){ formData.append('redirect_to', this.form.redirect_to); };
      

      this.loading = true;
      if (this.check_form()) {
      discover.createDiscover(formData)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE_DISCOVER', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        setTimeout(() => {  this.$router.push({name:'Discover Table'}) }, 1500);
      }).catch((err) => {
          this.loading = false;
          alert(err.response.data.message);
          //alert(JSON.stringify(err.response.data.errors));
          if (err.response.data.errors != null) {
              this.errors_from_backend = err.response.data.errors;
              console.log(JSON.stringify(err.response.data.errors));
          }
        });
      } else {
        this.loading = false;
        }
    },
    update(id){
      this.show = false;
      if(this.cb_redirect == false){ this.form.redirect_to = null };
      discover.updateDiscover(id, this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE_DISCOVER', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

    openModalPhotoBGImage(id){
        var params = {title: 'Update BG Image', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_EVENT_PHOTO_BGIMAGE_DISCOVER', params)
        console.log('load modal photo')      
    },
    openModalPhotoCardImage(id){
        var params = {title: 'Update Card Image', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_EVENT_PHOTO_CARDIMAGE_DISCOVER', params)
        console.log('load modal photo')      
    },
    clear(id){
      if(id == 'Back Button Text Color'){this.form.mobile_setting.back_button_setting.color = ''};
      if(id == 'Back Button BG Color'){this.form.mobile_setting.back_button_setting.bg_color = ''};
      if(id == 'Title Text Color'){this.form.mobile_setting.title.color = ''};
      if(id == 'Title BG Color'){this.form.mobile_setting.title.bg_color = ''};
      if(id == 'Author Text Color'){this.form.mobile_setting.author.color = ''};
      if(id == 'Content BG Color'){this.form.mobile_setting.bg_content = ''};
    },   
     check_form: function(e) {
         this.errors = {};
         if (!this.form.title) {
            this.errors["title"] = "1";
         }

         if (
            this.form.title
         ) {
            return true;
         } else {
            return false;
         }
      }, 

  }
}


</script>
<style>

h1 {
	height: 120px;
	line-height: 120px;
	text-align: center;
}
.vc-chrome {
	position: absolute;
	top: 35px;
	right: 0;
	z-index: 9;
}
.current-color {
	display: inline-block;
	width: 16px;
	height: 16px;
	background-color: #000;
	cursor: pointer;
}
.footer {
	margin-top: 20px;
	text-align: center;
}
</style>